// extracted by mini-css-extract-plugin
export var wrap = "solutions-module--wrap--1b5-Y";
export var inner = "solutions-module--inner--1-jlt";
export var items = "solutions-module--items--C4TWL";
export var items_inner = "solutions-module--items_inner--3BmQ1";
export var itemTitle = "solutions-module--itemTitle--1UDOP";
export var link = "solutions-module--link--BBqKv";
export var partners = "solutions-module--partners--33T5q";
export var partners_list = "solutions-module--partners_list--3sjJW";
export var lottieWrap = "solutions-module--lottieWrap--gss8s";